import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../userContext';
import DefaultLoading from '../common/DefaultLoading';

const AdminRoute = ({ children, loginRedirect, deniedRedirect }) => {
  const { user, userProfile, loading } = useUser();
  const loginTarget = loginRedirect || '/studio/login';
  const deniedTarget = deniedRedirect || '/studio/dashboard';

  if (loading) {
    return <DefaultLoading context="authentication" />;
  }

  if (!user) {
    return <Navigate to={loginTarget} replace />;
  }

  // Check if user is admin - updated to use role-based access
  const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const isDevSite = window.location.hostname === 'smilesflowdev-1514f.web.app';
  const isProduction = window.location.hostname === 'www.smilesflow.com' || window.location.hostname === 'smilesflow.com';
  
  // Check for admin role in userProfile, with fallback to email for localhost/dev
  const hasAdminRole = userProfile?.role === 'admin';
  const isAdminEmail = userProfile?.email === 'support@smilesflow.com' || user?.email === 'support@smilesflow.com';
  
  // Allow admin role on all environments, or admin email on localhost/dev as fallback
  const isAdmin = hasAdminRole || ((isLocalhost || isDevSite) && isAdminEmail);

  if (!isAdmin) {
    return <Navigate to={deniedTarget} replace />;
  }

  return children;
};

export default AdminRoute; 
